<template>
    <transition name="fade">
        <div class="add-brand">
            <div v-if="showSuccessModal" class="success-modal">
                <img src="@/assets/images/brands/img-submit-success.png" alt="" class="success-img" />
                <div class="success-title">信息提交成功</div>
                <div class="success-desc">品牌信息提交成功！我们将在1-3个工作日内完成审核，请耐心等待~</div>
                <div class="success-btn" @click="confirmSuccess">确 定</div>
            </div>
            <div v-else class="add-brand-body">
                <Icon type="md-close" class="close" @click="close" />
                <div class="title">{{ editData ? '编辑品牌信息' : '添加品牌信息' }}</div>
                <div class="form">
                    <div class="form-item">
                        <div class="form-label required">品牌名称</div>
                        <div class="form-input">
                            <AutoComplete
                                class="input-cls"
                                v-model="form.name"
                                @on-search="remoteSearch"
                                @on-select="handleBrandChange"
                                placeholder="请输入品牌名称"
                            >
                                <Option
                                    v-for="item in brandOptions"
                                    :key="item.id"
                                    :value="item.name"
                                    :label="item.name"
                                >
                                    <div
                                        class="brand-item"
                                    >
                                        <img :src="item.logo" alt="" class="brand-logo">
                                        <div class="brand-name">{{ item.name }}</div>
                                    </div>
                                </Option>
                            </AutoComplete>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-label required">品牌logo</div>
                        <div class="form-input">
                            <Upload
                                :action="upload_url"
                                :show-upload-list="false"
                                :before-upload="onBeforeLogoUpload"
                                accept="image/*"
                                :disabled="!!form.logo"
                            >
                                <div class="form-upload">
                                    <template v-if="form.logo">
                                        <img src="@/assets/images/icon-close-circle.png" alt="" class="del-icon" @click.stop="removeLogo" />
                                        <img :src="form.logo" v-viewer alt="" class="upload-image">
                                    </template>
                                    <template v-if="!form.logo">
                                        <img src="@/assets/images/icon-upload-brand.png" class="upload-icon" />
                                        <div class="upload-btn-text">上传品牌logo</div>
                                        <div class="upload-btn-text-sub">（建议正方形，清晰无水印）</div>
                                    </template>
                                </div>
                            </Upload>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-label required">证书类型</div>
                        <div class="form-input">
                            <Select
                                class="input-cls"
                                v-model="form.cert_type"
                                placeholder="请选择证书类型"
                            >
                                <Option
                                    v-for="item in certTypeOptions"
                                    :key="item.value"
                                    :value="item.value"
                                    :label="item.label"
                                >{{ item.label }}</Option>
                            </Select>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-label required">品牌证书</div>
                        <div class="form-upload-files-box">
                            <Upload
                                :action="upload_url"
                                :show-upload-list="false"
                                multiple
                                :before-upload="onBeforeCertUpload"
                            >
                                <div class="form-upload-files">
                                    <img src="@/assets/images/icon-upload-brand-file.png" alt="" class="upfile-icon" />
                                    <div class="upload-btn-text">点击上传图片/PDF证书</div>
                                    <div class="upload-btn-text-sub">（支持JPG、PDF格式文件大小不超过10MB）</div>
                                </div>
                            </Upload>
                            <div class="files-list">
                                <div class="file-item" v-for="(item, index) in form.cert_files" :key="index">
                                    <div class="item-left">
                                        <template v-if="util.test_image(item.url)">
                                            <img class="file-icon" :src="item.url" alt="" />
                                        </template>
                                        <template v-else>
                                            <a :href="item.url" target="_blank">
                                                <img class="file-icon" :src="util.get_image_icon(item.url)" alt="" />
                                            </a>
                                        </template>
                                        <div class="file-info">{{ item.name }}</div>
                                    </div>
                                    <img src="@/assets/images/icon-close-circle.png" alt="" class="del-icon" @click="removeCertFile(index)">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-label required">证书到期时间</div>
                        <DatePicker
                            class="input-cls"
                            type="date"
                            placeholder="请选择到期时间"
                            format="yyyy-MM-dd"
                            :value="form.expire_time"
                            @on-change="onChangeExpireTime"
                        ></DatePicker>
                    </div>
                    <div class="form-item">
                        <div class="form-label">品牌描述</div>
                        <div class="form-textarea">
                            <textarea v-model="form.brand_desc" placeholder="请输入品牌描述" :rows="5" maxlength="200"></textarea>
                            <span class="char-count">{{ form.brand_desc.length }}/200</span>
                        </div>
                    </div>
                </div>
                <div class="footer">
                    <div class="cancel-btn" @click="close">取消</div>
                    <div class="confirm-btn" @click="submit">{{ editData ? '保存修改' : '提交审核' }}</div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script> 
import { CreateUserBrand, SearchBrandLibrary, UpdateUserBrand } from '@/api/index';
import { uploadFileToOSS } from "@/utils/oss";
import util from "@/utils/util";
export default{
    name:'AddBrand',
    props:{
        editData:{
            type: Object,
            default: null
        }
    },
    data(){
        return{
            util: util,
            upload_url: process.uniEnv.BASE_API + "/util/upload-image",
            form:{
                name:'',
                logo:'',
                cert_type:'',
                cert_files:[],
                brand_desc:'',
                expire_time:'',
                relate_id:'',
            },
            brandOptions: [],
            brandLogoMap: {},
            loading: false,
            certTypeOptions: [
                { value: '1', label: '商标注册证书' },
                { value: '2', label: '品牌授权证书' }
            ],
            certUploadQueue: [],
            certDebounceTimer: null,
            submitting: false,
            showSuccessModal: false,
        }
    },
    mounted(){
        if (this.editData) {
            this.form.name = this.editData.name || ''
            this.form.logo = this.editData.logo || ''
            this.form.cert_type = this.editData.cert_type ? String(this.editData.cert_type) : ''
            this.form.cert_files = this.parseCertFiles(this.editData.cert_files)
            this.form.brand_desc = this.editData.brand_desc || ''
            this.form.expire_time = this.editData.expire_time || ''
            this.form.relate_id = this.editData.relate_id || ''
        }
    },
    watch:{
        'form.name'(newName) {
            const matched = this.brandOptions.find(item => item.name === newName)
            if (!matched) {
                this.form.relate_id = ''
            }
        }
    },
    methods:{
        onChangeExpireTime(value){
            // console.log('value====>',value);
            this.form.expire_time = value;
        },
        parseCertFiles(certFiles) {
            if (!certFiles) return []
            if (Array.isArray(certFiles)) return certFiles
            try {
                return JSON.parse(certFiles)
            } catch {
                return []
            }
        },
        close(){
            this.$emit('close')
        },
        confirmSuccess() {
            this.showSuccessModal = false
            this.$emit('success')
            this.$emit('close')
        },
        remoteSearch(query) {
            if (query) {
                this.loading = true
                SearchBrandLibrary({ keyword: query }).then(res => {
                    if (res.code === 0) {
                        this.brandOptions = (res.data || []).map(item => ({
                            id: item.id,
                            name: item.name,
                            logo: item.logo,
                        }))
                        this.brandLogoMap = {}
                        this.brandOptions.forEach(item => {
                            this.brandLogoMap[item.name] = item.logo
                        })
                    } else {
                        this.brandOptions = []
                        this.brandLogoMap = {}
                    }
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            } else {
                this.brandOptions = []
                this.brandLogoMap = {}
            }
        },
        handleBrandChange(value) {
            if (!value) return
            const matched = this.brandOptions.find(item => item.name === value)
            if (matched) {
                this.form.logo = matched.logo
                this.form.relate_id = matched.id
            }
        },
        async onBeforeLogoUpload(file) {
            const isImage = file.type.startsWith('image/');
            if (!isImage) {
                this.$layer.msg('请上传图片格式文件');
                return false;
            }
            const isLt10M = file.size / 1024 / 1024 < 10;
            if (!isLt10M) {
                this.$layer.msg('图片大小不能超过10MB');
                return false;
            }
            try {
                const url = await uploadFileToOSS(file, "brand", false);
                this.form.logo = url;
                this.$layer.msg('Logo上传成功');
            } catch (err) {
                console.error('Logo upload failed:', err);
                this.$layer.msg('Logo上传失败');
            }
            return false;
        },
        removeLogo() {
            this.form.logo = '';
        },
        async onBeforeCertUpload(file) {
            const isLt10M = file.size / 1024 / 1024 < 10;
            if (!isLt10M) {
                this.$layer.msg('文件大小不能超过10MB');
                return false;
            }
            this.certUploadQueue.push(file);
            if (this.certDebounceTimer) {
                clearTimeout(this.certDebounceTimer);
            }
            this.certDebounceTimer = setTimeout(() => {
                this.processCertFiles();
            }, 300);
            return false;
        },
        async processCertFiles() {
            const queue = [...this.certUploadQueue];
            this.certUploadQueue = [];
            for (const file of queue) {
                try {
                    const url = await uploadFileToOSS(file, "brand", false);
                    this.form.cert_files.push({ name: file.name, url: url });
                } catch (err) {
                    console.error('Cert upload failed:', err);
                    this.$layer.msg(file.name + ' 上传失败');
                }
            }
            this.$layer.msg('证书上传完成');
        },
        removeCertFile(index) {
            this.form.cert_files.splice(index, 1);
        },
        async submit() {
            if (!this.form.name) {
                this.$layer.msg('请输入品牌名称');
                return;
            }
            if (this.form.name.length > 100) {
                this.$layer.msg('品牌名称不能超过100个字符');
                return;
            }
            if (!this.form.logo) {
                this.$layer.msg('请上传品牌Logo');
                return;
            }
            if (!this.form.cert_type) {
                this.$layer.msg('请选择证书类型');
                return;
            }
            if (!this.form.cert_files.length) {
                this.$layer.msg('请上传品牌证书');
                return;
            }
            if(this.form.brand_desc.length>200){
                this.$layer.msg('品牌描述不能超过200字符');
                return;
            }
            if (this.submitting) return;
            this.submitting = true;
            try {
                const data = {
                    name: this.form.name,
                    logo: this.form.logo,
                    cert_type: this.form.cert_type,
                    cert_files: JSON.stringify(this.form.cert_files),
                    brand_desc: this.form.brand_desc,
                    expire_time: this.form.expire_time ? this.form.expire_time : '',
                    relate_id: this.form.relate_id || '',
                };
                const isEdit = !!this.editData
                if (isEdit) {
                    data.id = this.editData.id
                }
                console.log('param===>',data);
                const api = isEdit ? UpdateUserBrand : CreateUserBrand
                const res = await api(data);
                if (res.code === 0) {
                    this.showSuccessModal = true
                } else {
                    this.$layer.msg(res.msg || '提交失败');
                }
            } catch (err) {
                console.error('Submit brand failed:', err);
                this.$layer.msg('提交失败');
            }
            this.submitting = false;
        }
    }
}
</script>
<style lang="scss" scoped>
.add-brand{
    position:fixed;
    width:100vw;
    height:100vh;
    background:rgba(0,0,0,0.5);
    z-index:999;
    inset:0;
    display:flex;
    align-items:center;
    justify-content:center;
    .success-modal{
        width: 520px;
        background: #fff;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 60px 40px 40px;
        .success-img{
            width: 182px;
            height: 98px;
        }
        .success-title{
            color: #02C160;
            font-weight: bold;
            font-size: 26px;
            margin-top: 24px;
        }
        .success-desc{
            color: #666666;
            font-size: 14px;
            margin-top: 12px;
            text-align: center;
        }
        .success-btn{
            background: #ff5967;
            color: #fff;
            border-radius: 8px;
            width: 298px;
            height: 48px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            cursor: pointer;
            margin-top: 32px;
            user-select: none;
        }
    }
    .add-brand-body{
        width:920px;
        height:879px;
        overflow:hidden;
        background:#fff;
        border-radius:10px;
        position:relative;
        display:flex;
        flex-direction:column;
        .close{
            position:absolute;
            top:16px;
            right:16px;
            font-size:18px;
            color:#999;
            cursor:pointer;
        }
        .title{
            width:100%;
            padding-top:20px;
            padding-bottom:16px;
            border-bottom:1px solid #e0e0e0;
            text-align:center;
            color:#0f1115;
            font-weight:20px;
            font-weight:bold;
            user-select:none;
        }
        .form{
            width:100%;
            flex:1;
            overflow-y:auto;
            padding:20px 24px;
            display:flex;
            flex-direction:column;
            row-gap:24px;
            .form-item{
                display:flex;
                align-items:flex-start;
                column-gap:10px;
                .form-label{
                    color:#333;
                    font-size:14px;
                    width:fit-content;
                    margin-top:8px;
                    &.required::after{
                        content:"*";
                        color:red;
                        font-size:14px;
                    }
                }
                .form-input{
                    flex-shrink:0;
                    flex:1;
                    .input-cls{
                        width:100%;
                        ::v-deep .ivu-input{
                            width:100%;
                        }
                        .brand-item{
                            display:flex;
                            align-items:center;
                            column-gap:8px;
                            .brand-logo{
                                width:32px;
                                height:32px;
                            }
                            .brand-name{
                                font-size:14px;
                                color:#333;
                            }
                        }
                    }
                }
                .form-textarea{
                    flex-shrink:0;
                    flex:1;
                    position: relative;
                    textarea{
                        width: 100%;
                        border:1px solid #e3e3e3;
                        border-radius:8px;
                        outline:none;
                        padding:13px 16px;
                        resize:none;
                    }
                    .char-count{
                        position: absolute;
                        bottom: 8px;
                        right: 12px;
                        color: #999;
                        font-size: 12px;
                    }
                }
                .form-upload{
                    width:180px;
                    height:180px;
                    background:#f8f9fb;
                    border:1px dashed #e3e3e3;
                    display:flex;
                    flex-direction:column;
                    align-items:center;
                    justify-content:center;
                    cursor:pointer;
                    position:relative;
                    .upload-image{
                        width:100%;
                        height:100%;
                    }
                    .del-icon{
                        position:absolute;
                        top:8px;
                        right:8px;
                        cursor:pointer;
                        width:20px;
                        height:20px;
                    }
                    .upload-icon{
                        width:32px;
                        height:32px;
                    }
                    .upload-btn-text{
                        color:#999;
                        font-size:14px;
                        margin-top:12px;
                        margin-bottom:4px;
                    }
                    .upload-btn-text-sub{
                        color:#999;
                        font-size:12px;
                    }
                }
                .form-upload-files-box{
                    display:flex;
                    flex-direction:column;
                    flex:1;
                    row-gap:16px;
                    ::v-deep .ivu-upload{
                        width:100%;
                    }
                    .form-upload-files{
                        width:100%;
                        height:150px;
                        background:#fbf9fb;
                        border:1px dashed #e3e3e3;
                        display:flex;
                        align-items:center;
                        justify-content:center;
                        flex-direction:column;
                        user-select:none;
                        .upfile-icon{
                            width:32px;
                            height:32px;
                        }
                        .upfile-text{
                            color:#999;
                            font-size:14px;
                            margin-top:10px;
                            margin-bottom:4px;
                        }
                        .upfile-text-sub{
                            color:#999;
                            font-size:12px;
                        }
                    }
                    .files-list{
                        display:flex;
                        gap:16px;
                        flex-wrap:wrap;
                        .file-item{
                            width:calc(100% / 2 - 10px);
                            background:#f8f9fb;
                            border-radius:4px;
                            display:flex;
                            align-items:center;
                            justify-content:space-between;
                            padding:9px 12px 10px 8px;
                            .item-left{
                                display:flex;
                                align-items:center;
                                column-gap:8px;
                                width:calc(100% - 28px);
                                .file-icon{
                                    width:36px;
                                    height:36px;
                                    flex-shrink:0;
                                }
                                .file-info{
                                    color:#333;
                                    font-size:14px;
                                    user-select:none;
                                    width:calc(100% - 44px);
                                    white-space:nowrap;
                                    text-overflow:ellipsis;
                                    overflow:hidden;
                                }
                            }
                            .del-icon{
                                width:20px;
                                height:20px;
                                cursor:pointer;
                                flex-shrink:0;
                            }
                        }
                    }
                }
                
            }
        }
        .footer{
            width:100%;
            border-top:1px solid #e0e0e0;
            display:flex;
            align-items:center;
            justify-content:center;
            column-gap:10px;
            padding-top:18px;
            padding-bottom:22px;
            .cancel-btn{
                padding:10px 36px 9px 36px;
                color:#666;
                font-size:14px;
                font-weight:bold;
                cursor:pointer;
                border-radius:4px;
                border:1px solid #e3e3e3;
            }
            .confirm-btn{
                padding:10px 32px 9px 32px;
                color:#fff;
                font-size:14px;
                font-weight:bold;
                cursor:pointer;
                background:#ff5967;
                border-radius:4px;
            }
        }
    }
}
</style>